import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { SessionService } from '../../../Util/Session/session.service';

@Component({
  selector: 'app-employee-to-default-apply',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule],
  templateUrl: './employee-to-default-apply.component.html',
  styleUrl: './employee-to-default-apply.component.scss'
})
export class EmployeeToDefaultApplyComponent {
  SelectApprovalType: string = 'User';
  isDisabled: boolean = false;

  UserLoad: any[] = [];
  DepartmentLoad: any[] = [];
  UserID: any = null;
  //UserName: string = ''
  DepartmentId: any = null
  //DepartmentName: string = ''
  Report: string = 'rp1';

  Shift: any[] = [];
  //ShiftTitle: string = '';
  ShiftID: any = null;

  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common: CommonService,
    private activeModal: NgbActiveModal
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('GetEssDepartmentMaster');
    this.ComboLoad('shift');
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad;
        }
        else if (Combotype == 'GetEssDepartmentMaster') {
          this.DepartmentLoad = response.ComboLoad;
        }
        else if (Combotype == 'shift') {
          this.Shift = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  onSelectionChange(type: string, event: any) {
    if (type == 'Employee') {
      this.SelectApprovalType = event.target.value;
      this.UserID = null
      this.ShiftID = null
      this.DepartmentId = null
    }
    else if (type == 'Reporting') {
      this.Report = event.target.value;
    }
  }
  // onSelectChange(type: string) {
  //   if (type === 'User') {
  //     const selected = this.UserLoad.find(user => user.UserMasterId === this.UserID);
  //     this.UserName = selected ? selected.UserName : null;
  //   }
  //   else if (type === 'Department') {
  //     const selected = this.DepartmentLoad.find(dept => dept.DepartmentMasterID === this.DepartmentId);
  //     this.DepartmentName = selected ? selected.DepartmentName : null;
  //   }
  //   else if (type === 'Shift') {
  //     const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
  //     this.ShiftTitle = selected ? selected.ShiftTitle : null;
  //   }
  // }

  cancel() {
    this.activeModal.close();
  }

  apply() {
    if (this.SelectApprovalType == 'User') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.UserID,
        ReportType: this.Report,
        ApplyTo: 'all'
      };
      console.log(userData);
      this.activeModal.close(userData);
      //sessionStorage.setItem('userData', JSON.stringify(userData));
    }
    else if (this.SelectApprovalType == 'Shift') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.ShiftID,
        ApplyTo: 'all'
      };
      this.activeModal.close(userData);
      //sessionStorage.setItem('userData', JSON.stringify(userData));
    }
    else if (this.SelectApprovalType == 'Department') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.DepartmentId,
        ApplyTo: 'all'
      };
      this.activeModal.close(userData);
      // sessionStorage.setItem('userData', JSON.stringify(userData));
    }
    //this.activeModal.close();
  }

  applyToSelected(){
    if (this.SelectApprovalType == 'User') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.UserID,
        ReportType: this.Report,
        ApplyTo: 'selected'
      };
      console.log(userData);
      this.activeModal.close(userData);
    }
    else if (this.SelectApprovalType == 'Shift') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.ShiftID,
        ApplyTo: 'selected'
      };
      this.activeModal.close(userData);
    }
    else if (this.SelectApprovalType == 'Department') {
      const userData = {
        For: this.SelectApprovalType,
        ID: this.DepartmentId,
        ApplyTo: 'selected'
      };
      this.activeModal.close(userData);
    }
  }

  isButtonEnabled(): boolean {
    const userId = this.UserID;
    const shiftId = this.ShiftID;
    const departmentId = this.DepartmentId;
    return !!(userId || shiftId || departmentId);
  }
}
